// @ts-nocheck
import $ from 'jquery';
import hoverintent from 'hoverintent';
import { initiateFadeInUpAnimation, removeFadeInUpAnimation } from './fadeInUpAnimation';

export default class Menu {
  constructor(theme, element) {
    const self = this;
    this.theme = theme;
    this.element = element;
    this.$element = $(element);

    this.$nav = $('#AccessibleNav');
    this.$allLinks = this.$nav.find('a');
    this.$topLevel = this.$nav.children('li').find('a');
    this.$parents = this.$nav.find('.site-nav--has-dropdown');
    this.$mainLinks = this.$nav.find('.site-nav--has-dropdown.first-level-dropdown');
    this.$subMenus = this.$nav.find('.site-nav__dropdown');
    this.$subMenuLinks = this.$subMenus.find('a');
    this.activeClass = 'nav-hover';
    this.$sectionId = this.$element.attr('data-wetheme-section-id');
    this.$megaMenuDropdowns = document.querySelectorAll('.site-nav__dropdown.mega-menu-dropdown'); 
    this.$megaMenu = document.querySelector('.mega-menu-block');
    this.$megaMenuChildren = document.querySelectorAll('.mega-menu-block .dropdown-submenu');
    this.$resizeTimeout = null;

    this.$parents.each((i, el) => {
      this.setDropdownOffset($(el));
    });

    this.$subMenus.each((i, el) => {
      this.initScrollHandler(el);
    });

    this.adjustMegaMenuPosition();

    window.addEventListener('resize', () => {
      this.$parents.each((i, el) => {
        // If there's a scheduled resize, cancel it
        if (this.$resizeTimeout) {
          clearTimeout(this.$resizeTimeout);
        }

        // Schedule a new resize event to run 300ms from now
        this.$resizeTimeout = setTimeout(() => {
          this.$parents.each((i, el) => {
            this.setDropdownOffset($(el));
            this.adjustMegaMenuPosition();
          });
        }, 300);
      });
    });

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId == this.$sectionId) {
          this.$element.addClass('section-selected');
        } else {
          this.$element.removeClass('section-selected');
        }
      });

      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId == this.$sectionId) {
          this.$element.removeClass('section-selected');
        }
      });

      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail.sectionId == this.$sectionId) {
          this.adjustMegaMenuPosition();
        }
      });
    }

    this.$parents.on(
      'mouseover touchstart focusin',
      function(evt) {
        var ret = true;
        var $el = $(this);

        if (!$el.hasClass(self.activeClass)) {
          evt.preventDefault();
          self.hideDropdown($el.siblings());
          ret = false;
        }

        self.showDropdown($el);
        return ret;
      }
    );

    this.$parents.each(
      (i, el) => {
        hoverintent(
          el,
          function(evt) {
            $('.' + self.activeClass).each(function (el) {
              var $active = $(this);
              if ($active.has(evt.target).length === 0) {
                $active.removeClass(self.activeClass);
              }
            });
          },
          function() {
            // This is triggered when hovering over sub-menus /
            // child elements, so avoid using self.hideDropdown()
            // here.
          }
        );
      }
    );

    // Handle focus for submenus.
    this.$parents.each((i, el) => {
      $(el).on('focusin', function(elem) {
        self.showDropdown($(el));
      });
    });

    // Hide dropdown when moving away from top level links.
    this.$mainLinks.each((i, el) => {
      $(el).on('mouseleave', function(elem) {
        self.hideDropdown();
      });
    });

    // Mouseout / blur.
    $('.site-header').on('mouseleave', () => {
      self.hideDropdown();
    });

    $('.site-nav__dropdown').on('mouseleave focusout', (evt) => {
      self.hideDropdown($(this));
    });

    $(this.$megaMenu).on('mouseleave', () => {
      self.hideDropdown();
    });

    this.$subMenuLinks.on(
      'touchstart',
      function(evt) {
        // Prevent touchstart on body from firing instead of link
        evt.stopImmediatePropagation();
      }
    );

    this.$allLinks.on('focusin', function(evt) {
      let $el = $(this).parent();
      self.closeSiblings($el, evt);
    });

    $('.site-header').find('a, button, select').on('focusin', function() {
      // If this is not a menu (e.g. icon, logo), close all menus.
      let thisElem = this;
      let closeAllMenus = true;

      self.$allLinks.each(function() {
        if($(this).is(thisElem)) {
          closeAllMenus = false;
        }
      });

      if(closeAllMenus) {
        self.$parents.each(function() {
          self.hideDropdown($(this));
        });
      }
    });
  }

  initScrollHandler = ($el) => {
    const $container = $($el); 
    let scrolling;

    $container.on('scroll', () => {
      clearTimeout(scrolling);

      // Add class to show scrollbar
      $container.addClass('scrolling');

      scrolling = setTimeout(() => {
        // Remove class to hide scrollbar
        $container.removeClass('scrolling');
      }, 800);
    });
  }

  closeSiblings = ($el, evt) => {
    if (!$el.hasClass(this.activeClass)) {
      evt.preventDefault();
      this.hideDropdown($el.siblings());
    }
  }

  adjustMegaMenuPosition() {
    this.$megaMenuDropdowns.forEach((item) => {
      const menuItem = item.closest('.site-nav--has-dropdown');
      const menuItemRect = menuItem.getBoundingClientRect();

      item.style.left = `-${menuItemRect.left}px`; // Align the mega menu with the left edge of the viewport
    });
  }

  showDropdown = ($el) => {
    $el.addClass(this.activeClass);
    const self2 = this;

    // Initiate mega menu animation
    const megaMenuChildrenArray = Array.from($el.find('.mega-menu-block .dropdown-submenu'));
    initiateFadeInUpAnimation(megaMenuChildrenArray);

    // Remove iOS workaround because it breaks menu z-index
    $('.sticky-header').removeClass('sticky-header-transformed');

    setTimeout(function() {
      $(document.body).on(
        'touchstart',
        (evt) => {
          if (
            $(evt.target).closest('.site-nav__link,.dropdown-submenu').length === 0
          ) {
            // Hide dropdown if the touchstart was not on nav link
            self2.hideDropdown($el);
          }
        }
      );
    }, 250);
  }

  hideDropdown = ($el) => {
    if ($el !== undefined) {
      $el.removeClass(this.activeClass);

      // Remove mega menu animation 
      const megaMenuChildrenArray = Array.from($el.find('.mega-menu-block .dropdown-submenu'));
      if (!this.$element.hasClass('section-selected') && !this.$parents.hasClass('nav-hover')) {
        removeFadeInUpAnimation(megaMenuChildrenArray);
      }
    } else {
      $('.site-nav--has-dropdown').removeClass(this.activeClass);

      // Remove mega menu animation
      if (!this.$element.hasClass('section-selected') && !this.$parents.hasClass('nav-hover')) {
        removeFadeInUpAnimation(this.$megaMenuChildren);
      }
    }

    $(document.body).off('touchstart');

    // Reenable iOS workaround
    if ($('.nav-hover').length === 0) {
      $('.sticky-header').addClass('sticky-header-transformed');
    }
  }

  setDropdownOffset = ($el) => {
    const dropdown = $el.find('.site-nav__dropdown.standard-dropdown');

    if (dropdown.length === 0) return;

    const nav_position = $(dropdown).data('logoPlacement');
    const subDropdown = $(dropdown).find('.site-nav__subdropdown');

    // Get dropdown's distance from the right side of the window
    const dropdownRight = $(window).width() - (dropdown.offset().left + dropdown.outerWidth());

    // If it's less than 15px from the right edge of the window, it is too far right.
    if (dropdownRight < 15) {
      dropdown.css({
        right: '0',
        left: 'auto'
      });
    }

    if (subDropdown.length === 0) return;

    // Get the subdropdown's distance from the right side of the window
    const subDropdownRight = $(window).width() - (subDropdown.offset().left + subDropdown.outerWidth());

    if (subDropdownRight < 15) {
      if (nav_position == 'left' || nav_position == 'above') {
        subDropdown.css({
          left: 'auto',
          right: '100%'
        });
      } else {
        subDropdown.css({
          left: '100%',
          right: 'auto'
        });
      }
    }
  }
}
